'use strict';

angular.module('TurneroApp').constant('TurneroAppConstant', {
    vedi: {
        url: 'https://vedi.cordoba.gob.ar/',
        endpoint: {
            logout: 'Cuenta/CerrarSesion',
            login: 'VeDiLandingPage?idAplicacion=',
            alta: 'Cuenta/RegistracionExterna/'
        },
        ciDiIdAplicacion: 22,
        veDiIdAplicacion: 100, //Se sobreescribe con datos obtenidos el backend
        ciDiUrlRelacion: 'https://cidi.cba.gov.ar/portal/dashboard/servicios/ingreso-app?a=' //Se sobreescribe con datos obtenidos el backend
    },
    url: {
        Consulta_Telefonico: '/asistencia/consultatelefonico',
        Guia_Tramites_Municipal_Home: 'https://guiadetramites.cordoba.gob.ar/#/',
        Guia_Tramites_Municipal_Con_Id: 'https://guiadetramites.cordoba.gob.ar/#/tramite/'
    },
    integracionMiDocta: {
        /** Query en la URL del iframe que pide Mi Docta; activa alcance solo ciudadano (mis turnos + reserva). */
        queryParamModoCliente: 'modoClienteMiDocta',
        /** sessionStorage: persiste el modo aunque cambie la ruta sin query. */
        sessionStorageKeyModoCliente: 'turnero_modoClienteMiDocta'
    },
    server: {
        //url: 'https://turnos.cba.gov.ar/',
        //url: 'http://turnosdevtrs.cba.gov.ar/',
        //url: 'https://turnostest.cba.gov.ar/',
        //TODO: No utilizar. Sacar el FQDN de la url actual ya que siempre va a estar ruteada.
        //url: 'https://turnero-dev.test.cba.gov.ar/',
        //url: 'http://turnosdesa.cba.gov.ar/',
        //url: 'https://turnero.test.cba.gov.ar/',
        version: '4.0.0',
        entorno: 'Testing',
        server: '11'//'12'
    },
    TRS_Server: {
        url: 'http://trs2018.cba.gov.ar/#!/cedulon/'//[o_hash_trx]/[o_id_transaccion] --desa
        //url : 'http://trs2018test.cba.gov.ar/#!/cedulon/'//[o_hash_trx]/[o_id_transaccion] --test
        //url : 'http://trs.cba.gov.ar/#!/cedulon/'//[o_hash_trx]/[o_id_transaccion] --prod
    },
    endpointsSinToken: [
        "token",
        "api/CentroAtencion/comboLogin",
        "api/CentroAtencion/login",
        "api/Pregunta/Guardar_Respuestas",
        "api/Pregunta/Get_Preguntas_Turno",
        "api/General/Get_Version",
        "api/General/Get_Server_Id",
        "api/General/Errores_Post"
    ],
    HubNames: {
        PUESTOS: 'PuestosHub',
        TURNOS: 'TurnosHub',
        LLAMADOR: 'LlamadorHub',
    },
    TipoMotivos: {
        Bloqueo_de_Atencion: 1,
        Cancelacion_Agente: 2,
        Derivacion: 3,
        Atencion_No_Exitosa: 4,
        Retencion: 5,
        Reagendado_Ciudadano: 6,
        Reagendado_Agente: 7,
        Sistema: 8,
        Cancelacion_Ciudadano: 9
    },
    TipoDerivacion: {
        Agenda: 1,
        Grupo_Puestos: 3,
        Puesto: 5,
        Tramite: 6
    },
    Estados: {
        Generales: {
            Inactivo: 0,
            Activo: 1
        },
        Turno: {
            Agendado: 2,
            Cancelado: 3,
            Anunciado: 4,
            Reagendado: 5,
            Llamado: 6,
            Perdido: 7,
            Atendido: 8,
            Retenido: 9,
            Derivado: 10,
            Finalizado: 11,
            Eliminado: 12,
            A_validar: 13,
            Requiere_reagendado: 14
        },
        Agenda: {
            Habilitada: 15,
            Inhabilitada: 16,
            Eliminada: 17,
            Pendiente: 18
        },
        Encuesta: {
            Habilitada: 25,
            Inhabilitada: 26,
            Eliminada: 27
        }
    },
    Agenda_Vigencia: {
        Vigente: 'Vigente',
        Proxima_Vigente: 'Próximo a estar vigente',
        Vencida: 'Vencida',
        Proxima_Vencer: 'Por vencer'
    },
    Agenda_Vigencia_array: ['Vigente', 'Próximo a estar vigente', 'Vencida', 'Por vencer'],
    Modalidades: {
        Presencial: 1,
        OnLine: 2,
        Atencion_Telefonica: 3,
        Orden_de_Llegada: 4
    },
    Prioridades: {
        Sin_Prioridad: 0,
        Muy_Alta: 1,
        Alta: 2,
        Normal: 3,
        Baja: 4,
        Muy_Baja: 5

    },
    Derivacion: {
        Sin_Derivacion: 0,
        Derivado_Ami: 1,
        Derivado_Pormi: 2,
        Derivado_Otro: 3,
        Error: -1
    },
    ModalidadesArray: {
        Presencial: { Id: 1, Text: 'Presencial' },
        OnLine: { Id: 2, Text: 'On-Line' },
        Atencion_Telefonica: { Id: 3, Text: 'Atencion Telefonica' },
        Orden_de_Llegada: { Id: 4, Text: 'Orden de Llegada' }
    },
    Prioridad_Ley: {
        Embarazada: 'E',
        Mayor: 'A',
        Discapacitado: 'D',
        Sin_Prioridad: ''
    },

    TimbresArray: {
        Silent: { Id: 0, Text: 'Silencioso' },
        Ding_dong_In: { Id: 1, Text: 'Ding-dong-In' },
        Ding_dong_Out: { Id: 2, Text: 'Ding-dong-Out' },
        Ding_dong_In2: { Id: 3, Text: 'Ding-dong-In-2' },
        Ding_dong_Out2: { Id: 4, Text: 'Ding-dong-Out-2' },
        Ding1: { Id: 5, Text: 'ding1' },
        Ding2: { Id: 6, Text: 'ding2' }
    },
    Roles: {
        SU: 10
    },
    Tipo_Columnas: {
        Texto: 1,
        Numerico: 2,
        Combo: 3,
        Radiobutton: 4,
        Checkbox: 5
    },
    Permisos: {
        Consultar_Turnos_Supervision: 'CTS',
        Visualizar_Detalle_Turno_Supervision: 'DTS',
        Reimprimir_Turno_Supervision: 'RTS',
        Enviar_Mensaje_Supervision: 'EMS',
        Cancelar_Turno_Supervision: 'CAS',
        Cambiar_Estado_Supervision: 'CES',
        Visualizar_Estados_Puestos_Supervision: 'VSU',
        Visualizar_Estado_de_Salon_Supervision: 'VSS',
        Liberar_Puestos_Supervision: 'LPS',
        Reagendar_Turno_Supervision: 'RES',
        Dar_Turnos_Telefonicos: 'DTT',
        Enviar_Mensaje: 'EMT',
        Cambiar_Estado: 'CET',
        Dar_Turno: 'DAT',
        Anunciar_Turno: 'ATU',
        Consultar_Usuarios: 'CUS',
        Agregar_Usuario: 'AUS',
        Modificar_Usuario: 'MUS',
        Visualizar_Usuario: 'VUS',
        Eliminar_Usuario: 'EUS',
        Consultar_Puestos: 'CPU',
        Agregar_Puesto: 'APU',
        Modificar_Puesto: 'MPU',
        Visualizar_Puesto: 'VPU',
        Eliminar_Puesto: 'EPU',
        Consultar_Grupos: 'CGR',
        Agregar_Grupo: 'AGR',
        Modificar_Grupo: 'MGR',
        Visualizar_Grupo: 'VGR',
        Eliminar_Grupo: 'EGR',
        Consultar_Motivos: 'CMO',
        Agregar_Motivo: 'AMO',
        Modificar_Motivo: 'MMO',
        Visualizar_Motivo: 'VMO',
        Eliminar_Motivo: 'EMO',
        Consultar_Centros: 'CCE',
        Agregar_Centro: 'ACE',
        Modificar_Centro: 'MCE',
        Visualizar_Centro: 'VCE',
        Eliminar_Centro: 'ECE',
        Consultar_Turnos: 'CTU',
        Visualizar_Detalle_Turno: 'DTU',
        Reimprimir_Turno: 'RTU',
        Cancelar_Turno: 'CAT',
        Reagendar_Turno: 'RET',
        Consultar_Bloqueos: 'CBL',
        Agregar_Bloqueo: 'ABL',
        Modificar_Bloqueo: 'MB',
        Visualizar_Bloqueo: 'VB',
        Desactivar_Bloqueo: 'DBL',
        Visualizar_Estados_Puestos: 'VEP',
        Liberar_Puesto: 'LPU',
        Consultar_Agendas: 'CAG',
        Agregar_Agenda: 'AAG',
        Modificar_Agenda: 'MAG',
        Visualizar_Agenda: 'VAG',
        Eliminar_Agenda: 'EAG',
        Extender_Agenda: 'XAG',
        Historial_Agenda: 'HAG',
        Habilitar_Deshabilitar: 'HDA',
        Duplicar: 'DUG',
        Visualizar_Estado_De_Salon: 'VES',
        Visualizar_Reportes: 'VRE',
        Atencion: 'ATE',
        Consultar_Encuestas: 'CEN',
        Agregar_Encuesta: 'AEN',
        Modificar_Encuesta: 'MEN',
        Visualizar_Encuesta: 'VEN',
        Eliminar_Encuesta: 'EEN',
        Historial_Encuesta: 'HEN',
        Administrar_Tramites: 'ATR',
        SU: 'SU',
        Imprimir_Certificado: 'ICT',
        Reenviar_Certificado: 'RCT'
    },
    Modalidades_IFrame: {
        Online: 'O',
        Presencial: 'P'
    },
    HubDisconnectedIntervals: {
        //tiempo en milisegundos para la recarga de modulos sin hub
        General: 30000,
        Atencion: 30000,
    },
    Acciones: {
        Crear: 1,
        Editar: 2,
        Ver: 3,
        VerHistorial: 4
    },
    // ENCUESTAS
    TiposRespuesta: {
        UnoAlDiez: 1,
        SiNo: 2,
        Opciones: 3,
        Texto: 4
    }
});



// WEBPACK FOOTER //
// ./app/constants.js